import { useState, useEffect } from 'react'
import algoliasearch from 'algoliasearch/lite'
import {
  InstantSearch,
  Hits,
  Configure,
  useRefinementList,
} from 'react-instantsearch'
import { simple } from 'instantsearch.js/es/lib/stateMappings'

import AlgoliaIndexToolbar from './algolia-index-toolbar'
import AlgoliaIndexHit from './algolia-index-hit'
import AlgoliaIndexPagination from './algolia-index-pagination'
import AlgoliaNoResults from './templates/algolia-no-results'
import { NoResultsBoundary } from './algolia-boundaries'

function VirtualRefinementList(props) {
  useRefinementList(props)
  return null
}

export default function App() {
  const [searchClient, setSearchClient] = useState(null)
  const [startDateFilter, setStartDateFilter] = useState(null)
  const [endDateFilter, setEndDateFilter] = useState(null)

  const routing = {
    stateMapping: simple(),
  }

  const todayUnix = Math.floor(Date.now() / 1000)

  useEffect(() => {
    // Check if we're in the browser and API keys are available
    if (
      typeof window !== 'undefined' &&
      window.ALGOLIA_APPLICATION_ID &&
      window.ALGOLIA_SEARCH_API_KEY
    ) {
      const client = algoliasearch(
        window.ALGOLIA_APPLICATION_ID,
        window.ALGOLIA_SEARCH_API_KEY,
      )
      setSearchClient(client)
    }
  }, [])

  // Don't render InstantSearch until we have a valid search client
  if (!searchClient) {
    return null
  }

  return (
    <InstantSearch
      searchClient={searchClient}
      routing={routing}
      indexName={`wp_posts_${window.POST_TYPE}`}
      future={{
        preserveSharedStateOnUnmount: true,
        persistHierarchicalRootCount: true,
      }}>
      <VirtualRefinementList attribute="default_genre" />

      {window.POST_TYPE !== 'events' ? (
        <>
          <Configure analytics={false} hitsPerPage={10} />

          <NoResultsBoundary fallback={<AlgoliaNoResults />}>
            <Hits
              hitComponent={AlgoliaIndexHit}
              classNames={{
                list: 'grid grid-cols-3 max-md:grid-cols-1 gap-y-5xl max-md:gap-y-2xl mb-3xl',
              }}
            />
          </NoResultsBoundary>
        </>
      ) : (
        <>
          <Configure
            analytics={false}
            hitsPerPage={36}
            filters={`event_dates.start_date_unix >= ${todayUnix}${
              startDateFilter
                ? ` AND event_dates.start_date_unix >= ${startDateFilter}`
                : ''
            } ${
              endDateFilter
                ? `AND event_dates.end_date_unix <= ${endDateFilter}`
                : ''
            }`}
          />
          <NoResultsBoundary
            fallback={
              <AlgoliaNoResults
                callbacks={{
                  refine: () => {
                    setStartDateFilter(null)
                    setEndDateFilter(null)
                  },
                }}
              />
            }>
            <Hits hitComponent={AlgoliaIndexHit} />
          </NoResultsBoundary>
        </>
      )}
      <AlgoliaIndexToolbar
        state={{
          startDateFilter,
          endDateFilter,
        }}
        stateCallbacks={{
          setStartDateFilter,
          setEndDateFilter,
        }}
      />
      <AlgoliaIndexPagination />
    </InstantSearch>
  )
}
